<template>
  <a-modal
    :visible="visible"
    :footer="null"
    @cancel="closeModal"
    wrapClassName="get-info-modal"
    :title="title"
  >
    <div class="get-info-modal-container">
      <div class="get-info-modal-container__file-container">
        <div class="get-info-modal-container__file-container--image">
          <img
            :src="
              folder?.icon ?? require(`@/assets/icons/glocal-folder-icon.svg`)
            "
            alt="Image"
          />
        </div>
        <div class="get-info-modal-container__file-container--info">
          <h1>{{ folder?.name }}</h1>
          <p>Size: {{ folder?.size }}</p>
        </div>
      </div>
      <div class="get-info-modal-container__field">
        <p>Owner</p>
        <h1>{{ folder?.owner?.full_name }}</h1>
      </div>
      <div class="get-info-modal-container__field">
        <p>Total Files</p>
        <h1>{{ folder?.total_files }}</h1>
      </div>
      <div class="get-info-modal-container__field">
        <p>Total Articles</p>
        <h1>{{ folder?.total_articles }}</h1>
      </div>
      <div class="get-info-modal-container__field">
        <p>Created On</p>
        <h1>{{ folder?.created }}</h1>
      </div>
    </div>
  </a-modal>
</template>
<script>
export default {
  props: {
    folder: {
      require: true,
      default: () => ({}),
      type: Object,
    },
    visible: {
      required: true,
      default: false,
      type: Boolean,
    },
  },
  data: () => ({
    title: "Folder Information",
  }),
  emits: ["close-modal"],
  methods: {
    closeModal() {
      this.$emit("close-modal"), true;
    },
  },
};
</script>

<style lang="scss">
.get-info-modal {
  .ant-modal {
    width: 45rem !important;
    top: 9rem;
    .ant-modal-content {
      padding: 2.5rem 2.5rem 2.6rem;
      box-shadow: 0px 0px 94px #00000047;
      background: $color-white;
      border-radius: 1rem !important;
      .ant-modal-header {
        padding: 0;
        margin-bottom: 3rem;
        background-color: transparent;
        border: none;
        .ant-modal-title {
          font-size: 2.4rem;
          line-height: normal;
          font-family: $font-primary-bold;
          margin-bottom: 0;
          color: $color-black;
        }
      }
      .ant-modal-close {
        margin: 1.8rem 1.6rem 0 0;
      }
      .ant-modal-body {
        .get-info-modal-container {
          &__file-container {
            display: flex;
            align-items: center;
            margin-bottom: 2rem;
            gap: 1.2rem;
            border-bottom: 1px solid $color-dark-grey-5;
            padding-bottom: 1.5rem;
            &--image {
              width: 5rem;
              height: 4.5rem;
              border-radius: 0.5rem;
              overflow: hidden;
              border: 1px solid $color-dark-grey-5;
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                width: 2.7rem;
                height: auto;
              }
            }
            &--info {
              h1 {
                color: $color-black;
                font-size: 1.6rem;
                font-family: $font-primary-medium;
                line-height: normal;
                margin-bottom: 0.3rem;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 1; /* number of lines to show */
                line-clamp: 1;
                -webkit-box-orient: vertical;
              }
              p {
                color: $color-black;
                font-size: 1.3rem;
                font-family: $font-primary;
                line-height: normal;
                margin-bottom: 0;
                opacity: 0.7;
              }
            }
          }
          &__field {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 1.5rem;
            gap: 0.7rem;
            &:last-child {
              margin-bottom: 0;
            }
            p {
              color: $color-black;
              font-size: 1.6rem;
              font-family: $font-primary;
              line-height: normal;
              margin: 0;
              opacity: 0.7;
            }
            h1 {
              color: $color-black;
              font-size: 1.6rem;
              line-height: normal;
              font-family: $font-primary;
              margin: 0;
            }
          }
        }
      }
    }
  }
}
</style>
